module.exports = __webpack_public_path__ + "image/FH_logo2.png";